import { jwtDecode } from "jwt-decode";
import { EmployeeToken, ExpiringTokenPayload, TokenReadResult, UserToken } from "../amorg-common";
import { tokenReader } from "../amorg-common/modules/jsonWebToken/tokenReader";


export const clientTokenReader = {
    tryReadUserToken,
    tryReadEmployeeToken,
    tryReadAccessToken
}

function tryReadUserToken(
    token:string | undefined | null,
    lifeTimeSeconds?:number,
):TokenReadResult<UserToken>
{
    return tokenReader.tryReadUserToken(
        token,
        (token) => jwtDecode<ExpiringTokenPayload>(token),
        lifeTimeSeconds
    );
}

function tryReadEmployeeToken(token:string | undefined | null):TokenReadResult<EmployeeToken>
{
    return tokenReader.tryReadEmployeeToken(
        token,
        (token) => jwtDecode<ExpiringTokenPayload>(token),
    );
}


function tryReadAccessToken(token:string | undefined | null):TokenReadResult<UserToken | EmployeeToken>
{
    const result = tryReadUserToken(token);
    if(result.status === "no-token" || result.status === "invalid")
        return tryReadEmployeeToken(token);

    return result;
}